<template>
  <div id="repair-create-base">
    <div class="base" v-for="(item, index) in repairBase" :key="index">
      <edit-input
        v-if="!item.visibleDate"
        v-model="repairRecord[item.value]"
        :edit="visibleEdit"
        :label="item.label"
        :options="item.options || {}"
        :maxlength="item.maxlength"
        :showWordLimit="item.showWordLimit"
        :autosize="item.autosize"
        :placeholder="item.placeholder"
        :readonly="!!item.readonly"
      />
      <div v-if="item.visibleDate" class="base-date">
        <span class="edit-input__label font-labelheavy">{{ item.label }}</span>
        <el-date-picker
          v-model="repairRecord[item.value]"
          type="date"
          placeholder="选择日期"
          :class="{ readonly: !visibleEdit }"
          :readonly="!visibleEdit"
        >
        </el-date-picker>
      </div>
    </div>
  </div>
</template>

<script>
import editInput from '../layout/edit-input.vue';
export default {
  components: { editInput },
  props: {
    repairRecord: {
      type: Object,
      default: () => ({})
    },
    visibleEdit: {
      type: Boolean
    }
  },
  data() {
    return {
      repairBase: [
        {
          label: '记录编号：',
          value: 'recordFromUserId',
          placeholder: '请输入编号',
          visibleDate: false
        },
        {
          label: '动工日期：',
          value: 'acceptanceDate',
          visibleDate: true
        },
        {
          label: '竣工日期：',
          value: 'completionDate',
          visibleDate: true
        },
        {
          label: '施工单位：',
          value: 'constructionUnit',
          visibleDate: false,
          maxlength: 50,
          showWordLimit: true,
          rows: 4,
          placeholder: '请填写施工单位',
          autosize: {
            minRows: 3,
            maxRows: 8
          },
          options: {
            type: 'textarea'
          }
        },
        {
          label: '联系电话：',
          placeholder: '请填写施工单位联系电话',
          value: 'constructionUnitContact',
          maxlength: 20,
          showWordLimit: true,
          visibleDate: false
        },
        {
          label: '业主单位：',
          value: 'ownerUnit',
          visibleDate: false,
          maxlength: 50,
          showWordLimit: true,
          rows: 4,
          placeholder: '请填写业主单位',
          autosize: {
            minRows: 3,
            maxRows: 8
          },
          options: {
            type: 'textarea'
          }
        },
        {
          label: '联系电话：',
          placeholder: '请填写业主单位联系电话',
          value: 'ownerUnitContact',
          maxlength: 20,
          showWordLimit: true,
          visibleDate: false
        },
        {
          label: '修缮备注：',
          value: 'remark',
          visibleDate: false,
          maxlength: 500,
          showWordLimit: true,
          rows: 4,
          placeholder: '请填写',
          autosize: {
            minRows: 3,
            maxRows: 6
          },
          options: {
            type: 'textarea'
          }
        }
      ]
    };
  }
};
</script>

<style lang="scss">
#repair-create-base {
  .base {
    &-date {
      margin-top: 6px;
      .el-date {
        &-editor {
        }
      }
      .el-input {
        margin-left: 34px;
        width: 287px;
        height: 28px;
        &__inner {
          // padding: 0 3px;
          height: 28px;
          font-size: 13px;
          line-height: 28px;
          resize: none;
          border-radius: unset;
          border: 0;
          box-shadow: inset 0px 0px 3px 0px rgba(2, 125, 180, 0.7);
        }
        &__prefix {
          top: -5px;
        }
        &__suffix {
          top: -5px;
        }
      }
      .readonly {
        .el-input {
          &__inner {
            box-shadow: unset;
            cursor: text;
            border: 0px;
            padding-left: 3px;
          }
          &__prefix {
            display: none;
          }
        }
      }
    }
  }
}
</style>
